import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTitle from 'eco-design/base/eco-title';
import React from 'react';
import BaseDialog, { BaseDialogProps } from '../BaseDialog';
import style from './index.module.scss';

type Dialog2Props = BaseDialogProps;

const Dialog2: React.FC<Dialog2Props> = (props) => {
    const { t } = useLang('theProduct.SectionJ.item2_dialog');
    return (
        <BaseDialog className={style.comp} {...props}>
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <div className="list">
                <div className="item">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1753423255929/modal_pc_1.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1753415689055/modal_pad_1.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1753415688638/modal_h5_1.png"
                    />
                    <div className="item-title">{t('item1_title')}</div>
                    <div className="item-desc">{t('item1_desc')}</div>
                </div>
                {/* <div className="item">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744773954053/2.jpg" />
                    <div className="item-title">{t('item2_title')}</div>
                    <div className="item-desc">{t('item2_desc')}</div>
                </div> */}
                <div className="item">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1753423256298/modal_pc_2.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1753415688792/modal_pad_2.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1753415689499/modal_h5_2.png"
                    />
                    <div className="item-title">{t('item3_title')}</div>
                    <div className="item-desc">{t('item3_desc')}</div>
                </div>
            </div>
        </BaseDialog>
    );
};
export default Dialog2;
